
import axiosServices from './request';

const TradeCenter = axiosServices('tradecenter');
export default {
  //获取小程序订单
  getMiniOrderListByWechatUserId: TradeCenter('get', 'orderForm/getMiniOrderListByWechatUserId'),
  // 支付
  payForTool: TradeCenter('post', 'toolPay/payForTool'),
  //打包购买
  payForPackage: TradeCenter('post', 'orderForm/payForPackage'),

  /** 小睿伴学 */
  payForExerciseBook: TradeCenter('post', 'exerciseBook/payForExerciseBook'),
  /**伴学乐园会员购买 */
  payForLearnium: TradeCenter('post', 'learnium/payForLearnium'),

  // 支付正版授权费
  payForGenuine: TradeCenter('post', 'genuine/payForGenuine'),

  // 查书刊信息
  getOrderByBookId: TradeCenter('get', 'exerciseBook/getOrderByBookId')
};
